import { TextV2, InputSelectV2 } from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { Card, MenuItem } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useGetApplicationPreferredDialects } from 'domain/dialect';
import { useTranslation } from 'react-i18next';
import { Dialects, PreferredDialect } from 'types/dialects';
import { useBetaEnabled } from 'features';

type SignUpLanguageSelectionProps = {
  onSelect: (dialect: PreferredDialect) => void;
  value?: Dialects;
};

const SignUpLanguageSelection = ({
  onSelect,
  value,
}: SignUpLanguageSelectionProps) => {
  const isBetaEnabled = useBetaEnabled('supported-languages');
  const preferredDialects = useGetApplicationPreferredDialects(isBetaEnabled);
  const { t } = useTranslation();

  const items = [
    <MenuItem key="default" disabled value={undefined}>
      {t('ui.event-management.sign-up.preferred-language.placeholder')}
    </MenuItem>,
    ...Object.entries(preferredDialects).map<React.ReactNode>(
      ([item, language]) => (
        <MenuItem key={item} value={item}>
          {language}
        </MenuItem>
      ),
    ),
  ];

  return (
    <Card
      sx={(theme) => ({
        maxWidth: '500px',
        padding: `${theme.spacing(spacingSizeMap.L)} ${theme.spacing(
          spacingSizeMap.L,
        )}`,
      })}
    >
      <Grid container>
        <Grid size={12}>
          <TextV2 component="h1" variant="h3">
            {t('ui.event-management.sign-up.select-your-language.heading')}
          </TextV2>
        </Grid>
        <Grid
          size={12}
          sx={{
            mt: 2,
          }}
        >
          <InputSelectV2
            data-testid="preferred-dialect-select"
            id="preferredDialect"
            labelText={t(
              'ui.event-management.sign-up.preferred-language.input-label',
            )}
            type="text"
            variant="outlined"
            sx={{
              width: '100%',
              '& > div': {
                width: '100%',
              },
              input: {
                width: '100% !important',
              },
            }}
            defaultValue={undefined}
            onChange={(event) => {
              onSelect(event.target.value as PreferredDialect);
            }}
            value={value}
          >
            {items}
          </InputSelectV2>
        </Grid>
      </Grid>
    </Card>
  );
};

export default SignUpLanguageSelection;
